import { render, staticRenderFns } from "./ImageOrVideoPerColor.vue?vue&type=template&id=735bfb42"
import script from "./ImageOrVideoPerColor.vue?vue&type=script&lang=js"
export * from "./ImageOrVideoPerColor.vue?vue&type=script&lang=js"
import style0 from "./ImageOrVideoPerColor.vue?vue&type=style&index=0&id=735bfb42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports